export default function(baseApi) {
  return {
    api: `${baseApi}`,
    isProduction: true,
    isDevelopment: false,
    appName: 'MUSE'
  };
}
